
import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface AnimatedButtonProps extends React.ComponentPropsWithoutRef<typeof Button> {
  children: React.ReactNode;
  className?: string;
  delay?: number;
}

const AnimatedButton: React.FC<AnimatedButtonProps> = ({
  children,
  className,
  delay = 0,
  ...props
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay }}
    >
      <Button className={cn("", className)} {...props}>
        {children}
      </Button>
    </motion.div>
  );
};

export default AnimatedButton;
